import React from 'react'
import styled, {css} from 'styled-components'

import playBtnIcon from '@/images/icons/play-btn.svg'
import {useGlobalStrings} from '@/providers/global-strings'
import {colors, radii} from '@/theme'

interface Props extends Omit<React.HTMLProps<HTMLButtonElement>, 'size'> {
    'aria-label'?: string
    as?: any
    forwardedAs?: any
}

const PlayButtonComponent = React.forwardRef<HTMLButtonElement, Props>(
    (
        {
            as: PlayButtonElement = 'button',
            forwardedAs,
            'aria-label': ariaLabel,
            onClick,

            ...props
        },
        ref,
    ) => {
        const globalStrings = useGlobalStrings()
        return (
            <PlayButtonElement
                ref={ref}
                {...props}
                onClick={onClick}
                aria-label={ariaLabel || globalStrings.playVideo}
            />
        )
    },
)

export const playIconStyles = css`
    background-image: url(${playBtnIcon});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: ${radii.circle};
`

const StyledButton = styled(PlayButtonComponent)<{$size?: 'large'}>`
    background: transparent;
    display: block;
    width: ${(props) => (props.$size === 'large' ? '96px' : '40px')};
    aspect-ratio: 1 / 1;
    padding: 0;
    cursor: pointer;
    border: 1px solid ${colors.border.inverted};
    background-color: ${colors.button.default.background};
    ${playIconStyles};

    &:hover {
        background-color: ${colors.button.default.hover.background};
    }

    &:focus {
        border-color: ${colors.focusRing};
    }

    &:disabled {
        opacity: 0.25;
    }
`

export default StyledButton
